export default __webpack_public_path__ + "static/media/document.466b6ff6.svg";